export const PageText = {
  _1: 'Does air quality vary a lot?',
  _2: 'Recent studies, conducted in London, showed that changing your route to a healthier one can decrease your intake of specific pollutants up to 50-75%. (Ben Barrat, 2017 in De Standaard)'
};

export const Categories = {
  _1: {
    title: 'Variation in AQ',
    subcategories: [
      {
        key: 0,
        subtitle: 'Regularly changing',
        text: 'Air quality is directly linked to the proximity of pollution sources, like traffic, but also influenced by many other factors, such as weather. As all these factors vary quite a lot over time and space, the air quality changes rapidly. All this results in regularly changing aircheckr information.'
      },
      {
        key: 1,
        subtitle: 'Both in time and in space',
        text: 'Time: “An upcoming strong wind can blow away a considerable part of the heavy pollution in a few hours.”',
        text_2: 'Space: “The air quality next to a highway at rush hour can strongly differ from these in the park next to it.”',
        text_3: 'The illustration below shows the aircheckr AQI during one day for two points (highway and small road) only 200 meter away from each other. You can clearly see the considerable variations in time (e.g. AQI dropping with almost 45% in only 3 hours’ time) and space (the big difference between the two plots).'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/is-air-quality-varying-a-lot_page.js